import SectionHeading, {
  SectionHeadingType,
} from "@/components/atoms/SectionHeading";
import MarqueeCarousel from "@/components/organisms/Carousels/MarqueeCarousel";
import { SuccessStoryType } from "@/shared/types/common.types";
import SuccessStoriesMarqueeCard from "./Cards/SuccessStoriesMarqueeCard";

export type SuccessStoriesMarqueeSectionPropType = {
  title: SectionHeadingType;
  successStories: SuccessStoryType[];
};

const SuccessStoriesMarqueeSection = ({
  title,
  successStories,
}: SuccessStoriesMarqueeSectionPropType) => {
  return (
    <div className="flex flex-col gap-6 sm:gap-8">
      <div className="container text-start">
        <SectionHeading heading={title} />
      </div>

      <section className="group/marquee-container pointer-events-none relative overflow-x-hidden pb-2">
        <div className="absolute left-0 z-10 hidden h-full w-40 bg-gradient-to-l from-transparent to-white sm:block"></div>
        <div className="absolute right-0 z-10 hidden h-full w-40 bg-gradient-to-r from-transparent to-white sm:block"></div>
        <MarqueeCarousel pauseOnHover>
          {successStories.map((successStory, index) => (
            <SuccessStoriesMarqueeCard
              key={index}
              successStory={successStory}
            />
          ))}
        </MarqueeCarousel>
      </section>
    </div>
  );
};

export default SuccessStoriesMarqueeSection;
